import React from 'react';

export default function CalendarStyles() {
  return <style dangerouslySetInnerHTML={{__html: `
    .CalendarContainer,.CalendarContainer *,.CalendarContainer :after,.CalendarContainer :before{box-sizing:border-box}.CalendarContainer{border:1px solid #d3d3d3;background-color:#fff;width:324px;margin:0;padding:10px}.CalendarContainer>.CalendarHeader{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:-ms-grid;display:grid;-ms-grid-rows:auto;-ms-grid-columns:42px 1fr 42px;grid-template:auto/42px 1fr 42px;align-items:center;margin:0 auto;width:100%;color:#000}.CalendarContainer>.CalendarHeader h1{text-align:center;text-transform:none;font-size:24px;font-weight:700;line-height:30px;margin:0 0 10px;-ms-grid-column:2;grid-column:2}.CalendarContainer>.CalendarHeader input{display:block;font-size:small;font-weight:700;text-align:center;line-height:15px;height:18px;width:60px;margin:0 auto;border:none;background-color:transparent;border:1px solid #d3d3d3;padding-left:11px;font-family:inherit}.CalendarContainer>.CalendarHeader button{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:flex;box-shadow:none;-ms-grid-column-align:flex-end;align-self:flex-end;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;-ms-grid-row-align:center;justify-content:center;font-family:monospace;font-weight:700;font-size:16px;line-height:16px;background-color:#fff;border:1px solid #d3d3d3;height:42px;width:42px;margin-bottom:10px;padding:0}.CalendarContainer>.CalendarHeader button:first-of-type{-ms-grid-column:1;grid-column:1}.CalendarContainer>.CalendarHeader button:last-of-type{-ms-grid-column:3;grid-column:3}.CalendarContainer>.CalendarHeader button:disabled{opacity:.5}.CalendarContainer>.Calendar{color:#000}.CalendarContainer>.Calendar>.head{display:-ms-grid;display:grid;-ms-grid-rows:auto;-ms-grid-columns:(1fr)[7];grid-template:auto/repeat(7,1fr);margin-bottom:5px}.CalendarContainer>.Calendar>.head>.dayHeading{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-weight:700;font-size:small;text-align:center;text-transform:none}.CalendarContainer>.Calendar>.body{display:-ms-grid;display:grid;-ms-grid-rows:auto;-ms-grid-columns:(1fr)[7];grid-template:auto/repeat(7,1fr);grid-gap:1px;background-color:#eee;border:1px solid #eee}.CalendarContainer>.Calendar .CalendarDay{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:flex;transition:background-color .4s,box-shadow .4s,-webkit-transform .4s;transition:background-color .4s,transform .4s,box-shadow .4s;transition:background-color .4s,transform .4s,box-shadow .4s,-webkit-transform .4s;box-shadow:0 0 0 0 rgba(0,0,0,.2);align-items:center;justify-content:center;font-family:inherit;font-size:small;line-height:15px;margin:0;border:none;position:relative;padding:4px;width:42px;height:42px}.CalendarContainer>.Calendar .CalendarDay.isDisabled{cursor:default;color:#505050;background:#f6f6f6;font-weight:lighter}.CalendarContainer>.Calendar .CalendarDay:not(.isDisabled){cursor:pointer;background-color:#fff;color:#333;font-weight:400}.CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isHovered{-webkit-transform:scale(1.2);transform:scale(1.2);box-shadow:0 0 3px 0 rgba(0,0,0,.2);z-index:1;background-color:#cdf}.CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isFocused{z-index:2;background-color:#cdf}.CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isToday{border:1px dotted gray}.CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isHighlighted{background-color:gold}.CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isInRange{background-color:#1a66ff;color:#fff}.CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isSelected{font-weight:700;background-color:#004ce6;color:#fff;z-index:1}

    #small-calendar .CalendarContainer {
      width: auto;
      padding: 0;
      background: #000;
      border: none;
    }

    #small-calendar .CalendarContainer>.CalendarHeader h1 {
      margin: 0;
      background: #000;
      color: #fff;
      font-size: 16px;
      text-transform: uppercase;
    }

    #small-calendar .CalendarContainer>.CalendarHeader button {
      margin: 0;
      background: #000;
      border: 0;
      color: #fff;
    }

    #small-calendar .CalendarContainer>.CalendarHeader button:hover {
      color: #05c789;
    }

    #small-calendar .CalendarContainer>.CalendarHeader input {
      display: none;
    }

    #small-calendar .CalendarContainer>.Calendar>.head {
      margin-bottom: 1px;
      grid-gap: 1px;
      border: 1px solid #fff;
      border-width: 0 1px;
      background: #fff;
    }

    #small-calendar .CalendarContainer>.Calendar>.head>.dayHeading {
      height: 24px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    #small-calendar .CalendarContainer>.Calendar>.head>.dayHeading > abbr {
      text-transform: uppercase;
      color: #000;
      line-height: 1;
    }

    #small-calendar .CalendarContainer>.Calendar>.body {
      background: #777;
      border: 0;
    }

    #small-calendar .CalendarContainer>.Calendar .CalendarDay {
      width: auto;
      height: 24px;
      font-weight: bold;
      background: #fff !important;
      color: #000;
    }

    #small-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled) {
      background: #fff;
    }

    #small-calendar .CalendarContainer>.Calendar .CalendarDay.isDisabled {
      background: #fff;
      color: #ccc;
    }

    // TODO: Figure out the actual CSS rules. I got tired of trying to get the cascading to work

    #small-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isToday {
      background: #cccccc !important;
      border: none;
    }

    #small-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isSelected {
      background: #05c789 !important;
    }

    #small-calendar .CalendarContainer > .Calendar .CalendarDay:not(.isDisabled).isFocused {
      background: inherit;
      font-weight: bold;
      color: #000;
    }

    #small-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isHovered {
      transform: none;
    }

    #small-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled):not(.isFocused).isHovered {
      background: #eee;
    }

    #large-calendar .CalendarContainer {
      padding: 0;
      border: 1px solid #000;
    }

    #large-calendar .CalendarContainer>.CalendarHeader h1 {
      margin: 0;
      background: #fff;
      color: #000;
      font-size: 16px;
      text-transform: uppercase;
    }

    #large-calendar .CalendarContainer>.CalendarHeader button {
      margin: 0;
      background: #fff;
      border: 0;
      color: #000;
    }

    #large-calendar .CalendarContainer>.CalendarHeader button:hover {
      color: #05c789;
    }

    #large-calendar .CalendarContainer>.CalendarHeader input {
      display: none;
    }

    #large-calendar .CalendarContainer>.Calendar>.head {
      margin-bottom: 0;
      grid-gap: 0;
      background: #fff;
      border: 1px solid #000;
      border-width: 0 0 1px;
    }

    #large-calendar .CalendarContainer>.Calendar>.head>.dayHeading {
      height: 24px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    #large-calendar .CalendarContainer>.Calendar>.head>.dayHeading > abbr {
      text-transform: uppercase;
      color: #000;
      line-height: 1;
    }

    #large-calendar .CalendarContainer>.Calendar>.body {
      background: #000;
      border: none;
    }

    #large-calendar .CalendarContainer>.Calendar .CalendarDay {
      width: auto;
      height: 24px;
      font-weight: bold;
      background: #fff !important;
      color: #000;
    }

    #large-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled) {
      background: #fff;
    }

    #large-calendar .CalendarContainer>.Calendar .CalendarDay.isDisabled {
      background: #fff;
      color: #ccc;
    }

    #large-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isToday {
      background: #cccccc !important;
      border: none;
    }

    #large-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isSelected {
      background: #05c789 !important;
    }

    #large-calendar .CalendarContainer > .Calendar .CalendarDay:not(.isDisabled).isFocused {
      background: #05c789;
      font-weight: bold;
      color: #000;
    }

    #large-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled).isHovered {
      transform: none;
    }

    #large-calendar .CalendarContainer>.Calendar .CalendarDay:not(.isDisabled):not(.isFocused).isHovered {
      background: #eee;
    }
  `}}/>;
}